module.exports = "/../../dist/frontend/images/bigTitleLogoR.svg?0acfd7fe5533709d3ff539fc4fae2dd5";